import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

import { register } from "ol/proj/proj4";
import proj4 from "proj4";

import { Services, olExtended } from "geoportal-extensions-openlayers";
proj4.defs(
    "EPSG:2154",
    "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
  );
  register(proj4);
  
Services.getConfig({
  apiKey: "essentiels",
  onSuccess: () => {
    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(<App />);
  },
});
registerServiceWorker();
